import React from 'react';
import BubbleIncludedServices from 'src/components/Bubbles/BubbleIncludedServices';
import WhatIncludedInPrice from 'src/components/WhatIncludedInPrice';
import { useCurrency } from '@lt/localization';
import styles from './priceBadgeContainer.module.css';
import PriceBadge from '../../components/PriceBadge';

const PriceBadgeContainer = ({ fetching, isHotelOnly, value, ...props }) => {
  const { code, symbol } = useCurrency();
  if (!value && !fetching) {
    return null;
  }

  return (
    <span className={styles.container}>
      <PriceBadge
        value={value}
        currencyCode={code}
        currencySymbol={symbol}
        {...props}
      />
      {!isHotelOnly && (
        <span className={styles.tooltip}>
          <BubbleIncludedServices placement="bottom">
            <WhatIncludedInPrice />
          </BubbleIncludedServices>
        </span>
      )}
    </span>
  );
};

export default PriceBadgeContainer;
